import axios from './axios';

const ContactApi = {
    getAll: () => axios.get('/contact/info'),        // 🔁 исправлено
    update: (data) => axios.put('/contact/info', data), // 🔁 исправлено
    sendMessage: (data) => axios.post('/contact/message', data),
};

export default ContactApi;
